import { AxiosError } from "axios";
import { RoomNoteSaveErrorEnum } from "../../enums/RoomNoteSaveErrorEnum";

// notes is the saved note, null when the note was cleared
export type RoomNoteSaveResult =
    | { ok: true; notes: string | null }
    | { ok: false; error: RoomNoteSaveErrorEnum };

export const roomNoteSaveErrorFromApiError = (error: unknown): RoomNoteSaveErrorEnum => {
    if (!(error instanceof AxiosError)) return RoomNoteSaveErrorEnum.Failed;

    switch (error.response?.status) {
        case 400: return RoomNoteSaveErrorEnum.Validation;
        case 401: return RoomNoteSaveErrorEnum.Unauthorized;
        case 403: return RoomNoteSaveErrorEnum.Forbidden;
        case 404: return RoomNoteSaveErrorEnum.NotFound;
        default:  return RoomNoteSaveErrorEnum.Failed;
    }
};
